// extracted by mini-css-extract-plugin
export var button = "_aj-0";
export var icon = "_aj-1";